document.addEventListener("DOMContentLoaded", function () {
  function addTable() {
    const productForm = document.querySelector(".product-form");

    // Remove existing table before re-adding
    const existingTable = document.querySelector(".hatch-date");
    if (existingTable) existingTable.remove();

    const showSoldOut = document.createElement("div");
    showSoldOut.classList.add("hatch-date-check");
    showSoldOut.textContent = "Show Sold Out Dates";

    const hatchDateDiv = document.createElement("div");
    const hatchContainerDiv = document.createElement("div");
    const hatchBottomDiv = document.createElement("div");

    const urlTag = document.createElement("a");
    urlTag.href = "https://www.chickencoopcompany.com/pages/availability-chart";
    urlTag.textContent = "Show All Chicks Availability";
    urlTag.setAttribute("target", "_blank");
    urlTag.classList.add("btn", "btn__yellow");
    hatchBottomDiv.appendChild(urlTag);

    hatchDateDiv.classList.add("hatch-date");
    hatchContainerDiv.classList.add("hatch-container");

    hatchBottomDiv.classList.add("hatch-bottom");

    const titleDiv = document.createElement("div");
    titleDiv.classList.add("hatch-date__title");
    titleDiv.textContent = "Ship Date Selected at Checkout";

    const tableDiv = document.createElement("div");
    tableDiv.classList.add("hatch-date__table");

    const headDiv = document.createElement("div");
    headDiv.classList.add("hatch-date__head");

    headDiv.innerHTML = `
      <div class="hatch-date__block">Shipping Week</div>
      <div class="hatch-date__block">Availability</div>
      <div class="hatch-date__block">Other Breeds Available</div>
    `;

    const mainDiv = document.createElement("div");
    mainDiv.classList.add("hatch-date__main");

    tableDiv.appendChild(headDiv);
    tableDiv.appendChild(titleDiv);
    tableDiv.appendChild(mainDiv);

    hatchDateDiv.appendChild(tableDiv);
    productForm.appendChild(hatchContainerDiv);
    hatchContainerDiv.appendChild(hatchDateDiv);
    hatchContainerDiv.appendChild(hatchBottomDiv);
    hatchBottomDiv.appendChild(showSoldOut);

    // Hide initially
    hatchDateDiv.style.display = "none";
    showSoldOut.style.display = "none";
  }

  function addHatchDateMain(availability, availabilityVariant) {
    const hatchDateMain = document.querySelector(".hatch-date__main");
    const hatchDateCheckElement = document.querySelector(".hatch-date-check");
    const hatchDateContainer = document.querySelector(".hatch-date");
    const addToCartBtn = document.querySelector(".add-to-cart-btn");
    const mainTagPdp = document.querySelector(".main__tag-pdp");
    const productQty = document.querySelector(".product__qty");

    if (hatchDateMain) hatchDateMain.innerHTML = "";

    let hasAvailableDate = false;
    let stockVariantAvailable = false;

    addToCartBtn.classList.add("btn--disabled");

    // Parse the JSON data and check if the selected variant is available
    const variantsData = JSON.parse(
      document.getElementById("variants-json").textContent
    );
    const customCurrentVariant = document.querySelector(
      ".custom-current-variant"
    );
    const variantId = customCurrentVariant.textContent.trim();
    const variant = variantsData.find((variant) => variant.id === variantId);

    if (variant) {
      // Check if the variant is available
      stockVariantAvailable = variant.available === "true";

      Object.entries(availability).forEach(([key, value]) => {
        const status = value[availabilityVariant] || "UNAVAILABLE";
        if (status !== "UNAVAILABLE") hasAvailableDate = true;

        if (
          hatchDateCheckElement.classList.contains("show") ||
          status !== "UNAVAILABLE"
        ) {
          const dateObj = new Date(key);
          const formattedDate = `${(dateObj.getMonth() + 1)
            .toString()
            .padStart(2, "0")}/${dateObj
            .getDate()
            .toString()
            .padStart(2, "0")}/${dateObj.getFullYear()}`;
          const dateFilter = `${dateObj.getFullYear()}-${(
            dateObj.getMonth() + 1
          )
            .toString()
            .padStart(2, "0")}-${dateObj
            .getDate()
            .toString()
            .padStart(2, "0")}`;
          const filterLink = `https://www.chickencoopcompany.com/collections/chicks?filter.p.m.hatcherybrain_middleware.filter_shipping_date=${dateFilter}`;

          const hatchDateLine = document.createElement("div");
          hatchDateLine.classList.add("hatch-date__line");

          hatchDateLine.innerHTML = `
            <div class="hatch-date__block">${formattedDate}</div>
            <div class="hatch-date__block">${status}</div>
            <div class="hatch-date__block m-gr">
              <a href="${filterLink}" target="_blank">Other Breeds Available</a>
            </div>
          `;

          hatchDateMain.appendChild(hatchDateLine);
        }
      });
    }

    const forceSoldOut = mainTagPdp.dataset.forceSoldOut;
    console.log(forceSoldOut);
    if (forceSoldOut === "true") {
      addToCartBtn.disabled = true;
      addToCartBtn.classList.add("btn--disabled");
      mainTagPdp.classList.remove("bg-Accent-Teal-Darker");
      mainTagPdp.classList.add("!bg-Accent-Red");
      mainTagPdp.textContent = "Sold Out";

      productQty.disabled = true;
      productQty.classList.add("btn--disabled");

      hatchDateContainer.style.display = "none";
      hatchDateCheckElement.style.display = "none";

      addToCartBtn.textContent = "Out of Stock";
    } else {
      if (hasAvailableDate && stockVariantAvailable) {
        console.log(
          "Available dates found. Enabling add-to-cart, quantity, and showing table."
        );
        addToCartBtn.disabled = false;
        addToCartBtn.classList.remove("btn--disabled");
        mainTagPdp.classList.add("bg-Accent-Teal-Darker");
        mainTagPdp.classList.remove("!bg-Accent-Red");
        mainTagPdp.textContent = "IN STOCK!";

        productQty.disabled = false;
        productQty.classList.remove("btn--disabled");

        hatchDateContainer.style.display = "block";
        hatchDateCheckElement.style.display = "block";

        addToCartBtn.querySelector(".label").textContent = "Add to Cart";
      } else {
        console.log(
          "No available dates or stock is unavailable. Disabling add-to-cart, quantity, and hiding table."
        );
        addToCartBtn.disabled = true;
        addToCartBtn.classList.add("btn--disabled");
        mainTagPdp.classList.remove("bg-Accent-Teal-Darker");
        mainTagPdp.classList.add("!bg-Accent-Red");
        mainTagPdp.textContent = "Sold Out";

        productQty.disabled = true;
        productQty.classList.add("btn--disabled");

        hatchDateContainer.style.display = "none";
        hatchDateCheckElement.style.display = "none";

        addToCartBtn.querySelector(".label").textContent = "Out of Stock";
      }
    }
  }

  function fetchAvailabilityBySKU(sku) {
    const addToCartBtn = document.querySelector(".add-to-cart-btn");
    const productQty = document.querySelector(".product__qty");
    productQty.classList.add("btn--disabled");

    const fail = (error) => {
      console.error("Error loading availability by SKU:", error);

      addToCartBtn.disabled = true;
      addToCartBtn.classList.add("btn--disabled");

      productQty.disabled = true;
      productQty.classList.add("btn--disabled");

      document.querySelector(".hatch-date").style.display = "none";
      document.querySelector(".hatch-date-check").style.display = "none";
    };

    try {
      const el = document.getElementById("product-availability-json");
      if (!el || !el.textContent.trim()) {
        throw new Error("Missing #product-availability-json");
      }

      const payload = JSON.parse(el.textContent);
      const rows = payload[sku];
      if (!rows?.[0]?.availability) {
        console.error(
          "Invalid availability payload or unknown SKU",
          sku,
          payload
        );
        fail(new Error("Invalid availability data"));
        return;
      }

      const availability = rows[0].availability;
      const lastChar = sku.slice(-1);
      const availabilityVariant =
        lastChar === "F" ? "females" : lastChar === "M" ? "males" : "notSexed";

      addHatchDateMain(availability, availabilityVariant);
    } catch (error) {
      fail(error);
    }
  }

  function drawingTableById() {
    if (document.getElementById("custom_pr_variants") == null) {
      return;
    }
    const customPrVariants = JSON.parse(
      document.getElementById("custom_pr_variants").textContent
    );
    const customCurrentVariant = document.querySelector(
      ".custom-current-variant"
    );
    let variantId = customCurrentVariant.textContent.trim();

    if (!variantId) {
      console.error("No variant ID found.");
      return;
    }

    const variant = customPrVariants.find(
      (variant) => Object.keys(variant)[0] === variantId
    );
    if (variant) {
      const sku = variant[variantId];
      if (sku) {
        fetchAvailabilityBySKU(sku);
      } else {
        console.error("No SKU found for variant ID:", variantId);
      }
    } else {
      console.error("No matching variant found for ID:", variantId);
    }
  }

  const customCurrentVariant = document.querySelector(
    ".custom-current-variant"
  );

  if (customCurrentVariant) {
    if (customCurrentVariant.textContent.trim() === "") {
      const addToCartBtn = document.querySelector(".add-to-cart-btn");
      const productQty = document.querySelector(".product__qty");

      // addToCartBtn.disabled = true;
      // addToCartBtn.classList.add("disabled");

      productQty.disabled = true;
      productQty.classList.add("btn--disabled");

      document.querySelector(".hatch-date").style.display = "none";
      document.querySelector(".hatch-date-check").style.display = "none";
    }

    addTable();

    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (
          mutation.type === "childList" ||
          mutation.type === "characterData"
        ) {
          drawingTableById();
        }
      });
    });

    observer.observe(customCurrentVariant, {
      childList: true,
      characterData: true,
      subtree: true,
    });
  }

  document.querySelectorAll(".hatch-date-check").forEach(function (element) {
    element.addEventListener("click", function () {
      this.classList.toggle("show");
      drawingTableById();
    });
  });

  setTimeout(() => {
    drawingTableById();
  }, 50);
});
